export default __webpack_public_path__ + "static/media/event_banner.53e3385e.png";